import { SFG_GLOBALS } from './environment.sfg.globals';

export const environment = SFG_GLOBALS;

// Overwrite settings for this environment.
environment.name = 'production';
environment.apiConfiguration.baseUrl = 'https://api.sfg-ag.ch';
environment.apiConfiguration.publicApiKey = '4418104748cc4d3a6c2c5d7b6e4485bbd994e61d';
environment.appUrls.workOffice = 'https://office.sfg-ag.ch';
environment.appUrls.app = 'https://app.sfg-ag.ch';
environment.appUrls.geruestrechner = 'https://rechner.sfg-ag.ch';
environment.appUrls.website = 'https://www.sfg-ag.ch';
environment.appUrls.freigabe = 'https://freigabe.sfg-ag.ch';
environment.sentryDsn.app = 'https://e9aafd24a83d4aa1b47a0c5746df250d@bugs.digitalemenschen.dev/16';
environment.sentryDsn.office = 'https://5886876ae98743998affaca9a4482c73@bugs.digitalemenschen.dev/12';
environment.sentryDsn.geruestrechner = 'https://5433185709bc485abc3b80903ca9eda2@bugs.digitalemenschen.dev/3';
environment.googleMapApiKey = 'AIzaSyCz_WQ13DUqgawY2kxUejHhbqcJTqMCdB4';
